var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRedBoat = function SvgRedBoat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 108,
    viewBox: "0 0 164 108",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7204 70.9632L0 49.9775L55.3792 48.2286L43.7204 70.9632Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7204 70.9632L0 49.9775L55.3792 48.2286L43.7204 70.9632Z",
    fill: "url(#red_boat_paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.332 70.3805L106.678 47.6459L163.223 45.3141L125.332 70.3805Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.332 70.3805L106.678 47.6459L163.223 45.3141L125.332 70.3805Z",
    fill: "url(#red_boat_paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5322 89.9714L81.7583 0.777832L132.306 72.9694L91.5006 95.9338L81.5322 89.9714Z",
    fill: "url(#red_boat_paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7887 0L22.928 68.3508L81.7887 88.4672V0Z",
    fill: "url(#red_boat_paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0289 0.56723L22.1683 68.918L81.0289 89.0344V0.56723Z",
    fill: "url(#red_boat_paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2504 98.1761L0.777222 50.9096L77.1331 61.8454L164 46.2461L146.715 93.8656L80.2119 107.413L19.2504 98.1761Z",
    fill: "url(#red_boat_paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2504 98.1761L0.777222 50.9096L77.1331 61.8454L164 46.2461L146.715 93.8656L80.2119 107.413L19.2504 98.1761Z",
    fill: "url(#red_boat_paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4732 97.3981L0 50.1316L76.3558 61.0675L163.223 45.4681L145.938 93.0877L79.4347 106.635L18.4732 97.3981Z",
    fill: "url(#red_boat_paint7_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4732 97.3981L0 50.1316L76.3558 61.0675L163.223 45.4681L145.938 93.0877L79.4347 106.635L18.4732 97.3981Z",
    fill: "url(#red_boat_paint8_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "red_boat_paint0_linear",
    x1: 27.6896,
    y1: 48.2286,
    x2: 27.6896,
    y2: 70.9632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "red_boat_paint1_linear",
    x1: 134.95,
    y1: 45.3141,
    x2: 134.95,
    y2: 70.3805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "red_boat_paint2_linear",
    x1: 111.312,
    y1: -19.8235,
    x2: 96.6225,
    y2: 174.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "red_boat_paint3_linear",
    x1: 69.3675,
    y1: -25.6486,
    x2: 70.5333,
    y2: 161.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557327,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "red_boat_paint4_linear",
    x1: 81.2206,
    y1: 52.2689,
    x2: 65.5,
    y2: 0.999998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "red_boat_paint5_linear",
    x1: 82.3863,
    y1: 10.2589,
    x2: 82.3863,
    y2: 91.4794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC8387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "red_boat_paint6_linear",
    x1: 82.3863,
    y1: 25.4149,
    x2: 82.3863,
    y2: 135.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "red_boat_paint7_linear",
    x1: 80.4432,
    y1: 75.3914,
    x2: 81.6091,
    y2: 149.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D789F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "red_boat_paint8_linear",
    x1: -100.068,
    y1: 69.7565,
    x2: 231.031,
    y2: 69.3679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC8387"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedBoat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/red_boat.3b716ab5.svg";
export { ForwardRef as ReactComponent };